import AdminLayout from "../../../components/admin/layout/AdminLayout";
import { useLocation } from "react-router-dom";
import BidDetailedView from "../../../components/common/bid/BidDetailedView";
import useAuthStore from "../../../store/authStore";
import ManagerSidebar from "../../../components/managerLiveDashboard/sidebar/ManagerSidebar";

function BidDetailedViewPage() {
  const { userType } = useAuthStore();
  const location = useLocation();
  const ID = location.state || {};

  return (
    <AdminLayout
      sidebarComponent={userType === 'admin' ? undefined : ManagerSidebar}
    >
      <div className="p-0">
        <BidDetailedView bidID={ID} />
      </div>
    </AdminLayout>
  );
}

export default BidDetailedViewPage;
